import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Drawer,
  DrawerProps,
  FormInstance,
  Row,
  Upload,
} from 'antd';
import { omit } from 'lodash';
import { Form, Spin } from 'antd';
import { v4 as uuidV4 } from 'uuid';
import { FormBuilderProps } from '../../form-components/form-builder';
import { usePageProvider } from '../../../hooks';
import { makeCommonDataSource } from '../../../../domain/factories';
import {
  notificationFailed,
  notificationSuccess,
} from '../../../../infrastructure';
import { InitialValuePageProviderEntity } from '../../../../domain/entities';
import { PageProvider } from '../../../providers';
import { IndexPageWrapper } from '../page-wrapper';
import { AntdDataTable } from '../../data-table-component';
import { typeOf } from 'mathjs';

export interface DrawerImportProps extends DrawerProps {
  formBuilderProps?: FormBuilderProps;
  defaultValueFilter?: any;
  onValuesChange?(item: any, values: any, form: FormInstance): void;
  customModuleKey?: string;
}

export function DrawerImport(props: DrawerImportProps) {
  const { defaultValueFilter, onValuesChange, customModuleKey } = props;
  const [fileData, setFileData] = useState(undefined);
  const [loadingSubmit, setLoadingSubmit] = useState(undefined);
  const [showForm, setShowForm] = useState(true);
  const { moduleKey, id } = usePageProvider();
  const [form] = Form.useForm();

  const InitDrawerProps: DrawerProps = {
    ...omit(props ?? {}, ['formBuilderProps']),
    width: props.width ?? 500,
    title: props.title ?? 'Import',
  };

  const dataSourceImport = makeCommonDataSource({
    apiUrl: 'v1/event/import-data',
  });

  const updateShowForm = async ({ setShowForm }) => {
    await setShowForm(false);
    setTimeout(() => {
      setShowForm(true);
    }, 100);
  };

  async function handleAfterSave(response) {
    form.resetFields();
    updateShowForm({ setShowForm });
  }

  async function onFinish(payload: any) {
    try {
      setLoadingSubmit(true);
      await dataSourceImport.handleCreate(payload, {
        async onSuccess({ response }: any) {
          await handleAfterSave(response);
          setLoadingSubmit(false);
          notificationSuccess(['Import successfully']);
        },
        async onFailed({ message }) {
          notificationFailed([message as string]);
          setLoadingSubmit(false);
        },
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSubmit(false);
    }
  }

  async function onReset() {
    await form.resetFields();
    const fields = form.getFieldsValue();
    const payload = {};
    for (const key of Object.keys(fields)) {
      Object.assign(payload, { [key]: undefined });
    }
  }

  // useEffect(() => {
  //   if (defaultValueFilter) form.setFieldsValue(defaultValueFilter);
  // }, [defaultValueFilter]);

  function FooterDrawer() {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
        }}
      >
        <Button
          style={{ marginRight: '5px' }}
          onClick={() => {
            onReset();
          }}
        >
          Reset
        </Button>
        <Button type="primary" onClick={() => form.submit()}>
          Import
        </Button>
      </div>
    );
  }

  async function requestUpload({ file, onSuccess }: any): Promise<void> {
    try {
      const formData = new FormData();
      const documentId = uuidV4();
      formData.append('document_url', file);
      formData.append('document_id', documentId);
      // let res = null;
      await dataSourceImport.handleCustomRequest({
        paramRequest: {
          method: 'POST',
          url:
            process.env.REACT_APP_BASE_SERVICE_URL +
            'v1/event/import-data/import/upload',
          data: formData,
        },
        async onSuccess({ response }: any) {
          // res = response;
          if (response) {
            form.setFieldsValue({
              path: response,
              filename: file?.name,
              original_name: file?.name,
              type:
                !!customModuleKey && typeOf(customModuleKey) === 'string'
                  ? props?.customModuleKey
                  : !!moduleKey && typeOf(moduleKey) === 'string'
                  ? moduleKey
                  : null,
              fileList: [{ name: file?.name, loading: false }],
              files: [{ name: file?.name, loading: false }],
            });
          }
        },
        async onFailed({ message }) {
          form.setFieldsValue({
            fileList: [
              {
                name: file?.name,
                loading: false,
                status: 'error',
                response: message,
              },
            ],
            files: [
              {
                name: file?.name,
                loading: false,
                status: 'error',
                response: message,
              },
            ],
          });
          notificationFailed([message as string]);
        },
      });
    } catch (error) {
      console.log(error);
    } finally {
      // setLoadingSubmit(false);
    }
  }

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e.filter((item, index) => index === e.length - 1);
    }
    const f = e && e.fileList;
    const value = f.filter((item, index) => index === f.length - 1);
    return value;
  };

  const InitialValue: InitialValuePageProviderEntity<any> = {
    moduleKey: 'import' + '__' + customModuleKey,
    webUrl: '/users',
    apiUrl: 'v1/event/import-data',
  };

  const columns = [
    {
      title: 'File Name',
      key: 'filename',
      width: 100,
      dataIndex: 'filename',
    },
    // {
    //   title: 'Total Row',
    //   key: 'total_row',
    //   width: 60,
    //   dataIndex: 'total_row',
    // },
    // {
    //   title: 'Success Row',
    //   key: 'success_row',
    //   width: 60,
    //   dataIndex: 'success_row',
    // },
    // {
    //   title: 'Failed Row',
    //   key: 'failed_row',
    //   width: 60,
    //   dataIndex: 'failed_row',
    // },
  ];

  return (
    <Drawer
      style={{ overflow: 'hidden' }}
      {...InitDrawerProps}
      // footer={FooterDrawer()}
      width="600"
      footerStyle={{ height: '50px' }}
      destroyOnClose={true}
    >
      <Form
        form={form}
        layout="vertical"
        name="form-filter"
        scrollToFirstError
        onFinish={onFinish}
        onValuesChange={(item, values) => {
          if (onValuesChange) onValuesChange(item, values, form);
        }}
        initialValues={{
          event_id: id,
        }}
      >
        <Form.Item name="path" hidden></Form.Item>
        <Form.Item name="filename" hidden></Form.Item>
        <Form.Item name="original_name" hidden></Form.Item>
        <Form.Item name="type" hidden></Form.Item>
        <Form.Item name="event_id" hidden />
        <Row gutter={[8, 2]} wrap={true}>
          <Col span={24}>
            <div className="form-submit-request-import ">
              <Form.Item
                name="files"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[{ required: true, message: 'Please upload file.' }]}
              >
                <Upload.Dragger
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  name="files"
                  customRequest={requestUpload}
                  listType="text"
                >
                  <p className="ant-upload-hint fs-12">
                    Click or drag file to this area to upload
                  </p>
                </Upload.Dragger>
              </Form.Item>
            </div>
          </Col>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldsValue }) => {
              const values = getFieldsValue();
              return (
                <Col span={24} className="margin-top-10" hidden={!values?.path}>
                  <Form.Item>
                    <Button
                      className="btn btn-primary"
                      htmlType="submit"
                      size="middle"
                      loading={loadingSubmit}
                    >
                      <span className="cell-light">Upload</span>
                    </Button>
                  </Form.Item>
                </Col>
              );
            }}
          </Form.Item>
        </Row>
        {/* <FooterDrawer /> */}
      </Form>
      {showForm && (
        <PageProvider initialValue={InitialValue}>
          <IndexPageWrapper
            pageToolbarProps={{
              pageTitle: 'Import List',
              showBack: false,
              showNewData: false,
              showFilterBadge: false,
              showFilter: false,
              showSearch: false,
            }}
            padding={[]}
            showPageHeader={false}
            showPageHeaderSimple={true}
          >
            <AntdDataTable
              columns={columns}
              defaultColumnIgnored={['action', 'status', 'created_at']}
              style={{ width: '100%' }}
              size="small"
              rowActionProps={{
                actionIgnored: [
                  'activate',
                  'deactivate',
                  'detail',
                  'duplicate',
                  'update',
                ],
              }}
              onRow={null}
              rowSelection={null}
              defaultFilterRequestData={{
                ...(defaultValueFilter ? { ...defaultValueFilter } : {}),
                types:
                  !!customModuleKey && typeOf(customModuleKey) === 'string'
                    ? [props?.customModuleKey]
                    : !!moduleKey && typeOf(moduleKey) === 'string'
                    ? [moduleKey]
                    : [],
              }}
            />
          </IndexPageWrapper>
        </PageProvider>
      )}
    </Drawer>
  );
}
